import { RepositoryFactory } from "../repositories/RepositoryFactory";

const userRepository = RepositoryFactory.get("user");

const user = {
  namespaced: false,
  state: {
    error: null,
    user: false,
  },
  mutations: {
    error(state, status) {
      state.error = status;
    },
    user(state, user) {
      state.user = user;
    },
  },
  actions: {
    apiPost({ commit }, payload) {
      //console.log('Store apiUserGet');
      return userRepository
        .apiPost(payload)
        .then((resp) => {
          commit("success");

          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {});
    },
    startLogout({ commit }) {
      this.state.user = false;
      return userRepository
        .startLogout()
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },
    checkLogin({ commit }) {
      if (this.state.user.user_id > 0) {
        return true;
      } else {
        return userRepository
          .checkLogin()
          .then((resp) => {
            commit("success");
            return resp;
          })
          .catch((err) => {
            commit("error");
            return err;
          })
          .finally(() => {
            commit("stop_loading");
          });
      }
    },

    checkLoginDirect({ commit }, token) {
      return userRepository
        .checkLoginDirect(token)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },

    getHomePruefungen({ commit }, payload) {
      commit("start_loading");
      return userRepository
        .getHomePruefungen(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },

    getPruefungen({ commit }, payload) {
      commit("start_loading");
      return userRepository
        .getPruefungen(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },

    savePruefung({ commit }, payload) {
      commit("start_loading");
      return userRepository
        .savePruefung(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },
    saveVersnummer({ commit }, payload) {
      commit("start_loading");
      return userRepository
        .saveVersnummer(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },
    saveUserDaten({ commit }, payload) {
      commit("start_loading");
      return userRepository
        .saveUserDaten(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },

    resendPass({ commit }, payload) {
      commit("start_loading");
      return userRepository
        .resendPass(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },
    startLogin({ commit }, payload) {
      commit("start_loading");
      return userRepository
        .startLogin(payload)
        .then((resp) => {
          commit("success");
          return resp;
        })
        .catch((err) => {
          commit("error");
          return err;
        })
        .finally(() => {
          commit("stop_loading");
        });
    },
  },
  getters: {
    getUserStore: (state) => state.user,
  },
};

export default user;
